// import { useEffect, useMemo, useState } from "react";
// import {
//   X,
//   Truck,
//   Package,
//   Loader2,
//   ChevronRight,
//   Check,
//   ArrowLeft,
//   Weight,
//   Ruler,
// } from "lucide-react";
// import { toast } from "sonner";
// import axiosInstance from "../../services/axiosInstance";

// const STEPS = [
//   {
//     key: "carrier",
//     label: "Carrier",
//   },
//   {
//     key: "dimensions",
//     label: "Package",
//   },
//   {
//     key: "rates",
//     label: "Rate",
//   },
// ];

// const INITIAL_DIMENSIONS = {
//   weightValue: "",
//   weightUnit: "ounce",
//   height: "",
//   width: "",
//   length: "",
//   dimUnit: "inch",
// };

// function getRatePrice(rate) {
//   return Number(
//     rate?.price ??
//       rate?.rate ??
//       rate?.shipping_amount ??
//       rate?.amount ??
//       0,
//   );
// }

// export default function ShippingLabelModal({
//   order,
//   onClose,
//   onLabelGenerated,
// }) {
//   const [stepIdx, setStepIdx] = useState(0);

//   const [carriers, setCarriers] = useState([]);
//   const [loadingCarriers, setLoadingCarriers] = useState(true);
//   const [selectedCarrier, setSelectedCarrier] = useState(null);

//   const [dimensions, setDimensions] = useState(INITIAL_DIMENSIONS);

//   const [rates, setRates] = useState([]);
//   const [loadingRates, setLoadingRates] = useState(false);
//   const [selectedRate, setSelectedRate] = useState(null);

//   const [generating, setGenerating] = useState(false);

//   const step = STEPS[stepIdx].key;

//   useEffect(() => {
//     let mounted = true;

//     const loadCarriers = async () => {
//       try {
//         setLoadingCarriers(true);

//         const res = await axiosInstance.get("/orders/admin/carriers");

//         if (!mounted) return;

//         setCarriers(
//           res?.data?.data?.carriers ??
//             res?.data?.carriers ??
//             [],
//         );
//       } catch (error) {
//         toast.error(
//           error?.response?.data?.message ||
//             "Couldn't load carriers",
//         );
//       } finally {
//         if (mounted) {
//           setLoadingCarriers(false);
//         }
//       }
//     };

//     loadCarriers();

//     return () => {
//       mounted = false;
//     };
//   }, []);

//   const goBack = () => {
//     setStepIdx((prev) => Math.max(prev - 1, 0));
//   };

//   const handleCarrierSelect = (carrier) => {
//     setSelectedCarrier(carrier);
//     setRates([]);
//     setSelectedRate(null);
//     setStepIdx(1);
//   };

//   const handleDimensionChange = (field, value) => {
//     if (value !== "" && Number(value) < 0) {
//       return;
//     }

//     setDimensions((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const validatePackage = () => {
//     const fields = [
//       ["weightValue", "Weight"],
//       ["height", "Height"],
//       ["width", "Width"],
//       ["length", "Length"],
//     ];

//     for (const [field, label] of fields) {
//       const value = dimensions[field];

//       if (value === "" || value === null || value === undefined) {
//         toast.error(`${label} is required`);
//         return false;
//       }

//       if (Number(value) <= 0) {
//         toast.error(`${label} must be greater than 0`);
//         return false;
//       }
//     }

//     if (!selectedCarrier) {
//       toast.error("Please select a carrier");
//       return false;
//     }

//     return true;
//   };

//   const handleGetRates = async () => {
//     if (!validatePackage()) return;

//     try {
//       setLoadingRates(true);

//       const payload = {
//         carrier_id: selectedCarrier.carrier_id,
//         packages: [
//           {
//             weight: {
//               value: Number(dimensions.weightValue),
//               unit: dimensions.weightUnit,
//             },
//             dimensions: {
//               height: Number(dimensions.height),
//               width: Number(dimensions.width),
//               length: Number(dimensions.length),
//               unit: dimensions.dimUnit,
//             },
//           },
//         ],
//       };

//       const res = await axiosInstance.post(
//         `/orders/admin/${order.id}/rates`,
//         payload,
//       );

//       const fetchedRates =
//         res?.data?.data?.rates ??
//         res?.data?.rates ??
//         [];

//       setRates(fetchedRates);
//       setSelectedRate(null);
//       setStepIdx(2);
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message ||
//           "Couldn't fetch shipping rates",
//       );
//     } finally {
//       setLoadingRates(false);
//     }
//   };

//   const handleGenerateLabel = async () => {
//     if (!selectedRate) {
//       toast.error("Please select a shipping rate");
//       return;
//     }

//     try {
//       setGenerating(true);

//       const payload = {
//         rate_id: selectedRate.rate_id,
//         service_name:
//           selectedRate.service_name ??
//           selectedRate.service_type,
//         carrier_name:
//           selectedRate.carrier_name ??
//           selectedCarrier?.carrier_name ??
//           selectedCarrier?.friendly_name,
//         price: getRatePrice(selectedRate),
//         delivery_days: selectedRate.delivery_days,
//       };

//       const res = await axiosInstance.post(
//         `/orders/admin/${order.id}/label`,
//         payload,
//       );

//       toast.success("Shipping label generated");

//       const labelUrl =
//         res?.data?.data?.label_url ??
//         res?.data?.label_url;

//       if (labelUrl) {
//         window.open(
//           labelUrl,
//           "_blank",
//           "noopener,noreferrer",
//         );
//       }

//       onLabelGenerated?.(res?.data);

//       onClose();
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message ||
//           "Couldn't generate label",
//       );
//     } finally {
//       setGenerating(false);
//     }
//   };

//   const cheapestId = useMemo(() => {
//     if (!rates.length) return null;

//     return rates.reduce((a, b) =>
//       getRatePrice(a) <= getRatePrice(b) ? a : b,
//     )?.rate_id;
//   }, [rates]);

//   const fastestId = useMemo(() => {
//     if (!rates.length) return null;

//     return rates.reduce((a, b) =>
//       Number(a?.delivery_days ?? 999) <=
//       Number(b?.delivery_days ?? 999)
//         ? a
//         : b,
//     )?.rate_id;
//   }, [rates]);

//   return (
//     <div
//       className="modal d-block"
//       tabIndex="-1"
//       role="dialog"
//       style={{
//         backgroundColor: "rgba(0, 0, 0, 0.70)",
//         zIndex: 1080,
//       }}
//     >
//       <div
//         className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
//         style={{
//           maxWidth: "560px",
//           width: "calc(100% - 30px)",
//         }}
//       >
//         <div
//           className="modal-content border-0 shadow-lg overflow-hidden"
//           style={{
//             borderRadius: "16px",
//           }}
//         >
//           {/* Header */}
//           <div className="border-bottom bg-light">
//             <div className="d-flex align-items-center justify-content-between px-4 py-3">
//               <div className="d-flex align-items-center gap-3">
//                 <div
//                   className="d-flex align-items-center justify-content-center flex-shrink-0"
//                   style={{
//                     width: 38,
//                     height: 38,
//                     borderRadius: 9,
//                     backgroundColor: "#1E3A5F",
//                   }}
//                 >
//                   <Truck size={17} color="white" />
//                 </div>

//                 <div className="min-w-0">
//                   <h6 className="fw-bold text-dark mb-1">
//                     Generate Shipping Label
//                   </h6>

//                   <div className="small text-muted">
//                     {order?.order_number ?? order?.order_id ?? order?.id}
//                   </div>
//                 </div>
//               </div>

//               <button
//                 type="button"
//                 onClick={onClose}
//                 className="btn btn-sm btn-light rounded-circle d-flex align-items-center justify-content-center"
//                 style={{
//                   width: 32,
//                   height: 32,
//                 }}
//               >
//                 <X size={17} />
//               </button>
//             </div>

//             {/* Stepper */}
//             <div className="px-4 pb-3">
//               <div className="d-flex align-items-center">
//                 {STEPS.map((item, index) => {
//                   const isDone = index < stepIdx;
//                   const isCurrent = index === stepIdx;
//                   const clickable = index < stepIdx;

//                   return (
//                     <div
//                       key={item.key}
//                       className={`d-flex align-items-center ${
//                         index === STEPS.length - 1
//                           ? ""
//                           : "flex-grow-1"
//                       }`}
//                     >
//                       <button
//                         type="button"
//                         disabled={!clickable}
//                         onClick={() => {
//                           if (clickable) {
//                             setStepIdx(index);
//                           }
//                         }}
//                         className="btn btn-link text-decoration-none p-0 d-flex align-items-center gap-2"
//                       >
//                         <span
//                           className="rounded-circle d-flex align-items-center justify-content-center fw-bold flex-shrink-0"
//                           style={{
//                             width: 28,
//                             height: 28,
//                             fontSize: 11,
//                             backgroundColor: isDone
//                               ? "#10B981"
//                               : isCurrent
//                                 ? "#1E3A5F"
//                                 : "#E5E7EB",
//                             color:
//                               isDone || isCurrent
//                                 ? "#fff"
//                                 : "#9CA3AF",
//                           }}
//                         >
//                           {isDone ? (
//                             <Check
//                               size={13}
//                               strokeWidth={3}
//                             />
//                           ) : (
//                             index + 1
//                           )}
//                         </span>

//                         <span
//                           className="small fw-semibold text-nowrap"
//                           style={{
//                             color: isCurrent
//                               ? "#1E3A5F"
//                               : isDone
//                                 ? "#4B5563"
//                                 : "#9CA3AF",
//                           }}
//                         >
//                           {item.label}
//                         </span>
//                       </button>

//                       {index < STEPS.length - 1 && (
//                         <div
//                           className="mx-2 rounded flex-grow-1"
//                           style={{
//                             height: 2,
//                             backgroundColor:
//                               index < stepIdx
//                                 ? "#34D399"
//                                 : "#E5E7EB",
//                           }}
//                         />
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>

//           {/* Body */}
//           <div
//             className="modal-body p-4"
//             style={{
//               minHeight: 300,
//             }}
//           >
//             {/* STEP 1 */}
//             {step === "carrier" && (
//               <div>
//                 <div className="mb-3">
//                   <h6 className="fw-bold mb-1">
//                     Select Carrier
//                   </h6>
//                   <p className="text-muted small mb-0">
//                     Choose the carrier you want to use for
//                     this shipment.
//                   </p>
//                 </div>

//                 {loadingCarriers ? (
//                   <div className="text-center py-5 text-muted">
//                     <Loader2
//                       size={24}
//                       className="spin mb-2"
//                     />
//                     <div className="small">
//                       Loading carriers...
//                     </div>
//                   </div>
//                 ) : carriers.length === 0 ? (
//                   <div className="text-center py-5 text-muted">
//                     <Package
//                       size={28}
//                       className="mb-2 opacity-50"
//                     />
//                     <div className="small">
//                       No carriers available.
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="d-flex flex-column gap-2">
//                     {carriers.map((carrier) => (
//                       <button
//                         key={carrier.carrier_id}
//                         type="button"
//                         onClick={() =>
//                           handleCarrierSelect(carrier)
//                         }
//                         className="btn text-start border rounded-3 p-3"
//                         style={{
//                           transition: "all .15s ease",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.currentTarget.style.borderColor =
//                             "#60A5FA";
//                           e.currentTarget.style.backgroundColor =
//                             "#EFF6FF";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.currentTarget.style.borderColor =
//                             "#DEE2E6";
//                           e.currentTarget.style.backgroundColor =
//                             "#fff";
//                         }}
//                       >
//                         <div className="d-flex align-items-center gap-3">
//                           <div
//                             className="rounded-3 bg-light d-flex align-items-center justify-content-center flex-shrink-0"
//                             style={{
//                               width: 40,
//                               height: 40,
//                             }}
//                           >
//                             <Truck
//                               size={17}
//                               className="text-secondary"
//                             />
//                           </div>

//                           <div className="flex-grow-1">
//                             <div className="fw-semibold text-dark small">
//                               {carrier.friendly_name ??
//                                 carrier.carrier_name ??
//                                 carrier.carrier_id}
//                             </div>

//                             {carrier.carrier_name &&
//                               carrier.friendly_name && (
//                                 <div className="text-muted small mt-1">
//                                   {
//                                     carrier.carrier_name
//                                   }
//                                 </div>
//                               )}
//                           </div>

//                           <ChevronRight
//                             size={17}
//                             className="text-muted"
//                           />
//                         </div>
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             )}

//             {/* STEP 2 */}
//             {step === "dimensions" && (
//               <div>
//                 <div
//                   className="alert alert-primary d-flex align-items-center gap-2 py-2 px-3 mb-4"
//                   role="alert"
//                 >
//                   <Truck size={15} />

//                   <div className="small">
//                     Carrier:{" "}
//                     <strong>
//                       {selectedCarrier?.carrier_name ??
//                         selectedCarrier?.friendly_name ??
//                         selectedCarrier?.carrier_id}
//                     </strong>
//                   </div>
//                 </div>

//                 {/* Weight */}
//                 <div className="mb-4">
//                   <label className="form-label small fw-bold text-secondary d-flex align-items-center gap-2">
//                     <Weight size={14} />
//                     Weight
//                   </label>

//                   <div className="input-group">
//                     <input
//                       type="number"
//                       min="0"
//                       step="0.01"
//                       placeholder="0"
//                       className="form-control"
//                       value={dimensions.weightValue}
//                       onWheel={(e) =>
//                         e.currentTarget.blur()
//                       }
//                       onChange={(e) =>
//                         handleDimensionChange(
//                           "weightValue",
//                           e.target.value,
//                         )
//                       }
//                     />

//                     <span className="input-group-text text-muted">
//                       oz
//                     </span>
//                   </div>
//                 </div>

//                 {/* Dimensions */}
//                 <div>
//                   <label className="form-label small fw-bold text-secondary d-flex align-items-center gap-2">
//                     <Ruler size={14} />
//                     Dimensions (in)
//                   </label>

//                   <div className="row g-3">
//                     {[
//                       {
//                         key: "height",
//                         label: "Height",
//                       },
//                       {
//                         key: "width",
//                         label: "Width",
//                       },
//                       {
//                         key: "length",
//                         label: "Length",
//                       },
//                     ].map(({ key, label }) => (
//                       <div className="col-4" key={key}>
//                         <input
//                           type="number"
//                           min="0"
//                           step="0.01"
//                           placeholder="0"
//                           className="form-control text-center"
//                           value={dimensions[key]}
//                           onWheel={(e) =>
//                             e.currentTarget.blur()
//                           }
//                           onChange={(e) =>
//                             handleDimensionChange(
//                               key,
//                               e.target.value,
//                             )
//                           }
//                         />

//                         <div className="text-center text-muted mt-1 small">
//                           {label}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* STEP 3 */}
//             {step === "rates" && (
//               <div>
//                 <div className="mb-3">
//                   <h6 className="fw-bold mb-1">
//                     Select Shipping Rate
//                   </h6>
//                   <p className="text-muted small mb-0">
//                     Choose the shipping service for this
//                     order.
//                   </p>
//                 </div>

//                 {rates.length === 0 ? (
//                   <div className="text-center py-5 text-muted">
//                     <Package
//                       size={28}
//                       className="mb-2 opacity-50"
//                     />

//                     <div className="small">
//                       No rates found for this
//                       carrier/package.
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="d-flex flex-column gap-2">
//                     {rates.map((rate) => {
//                       const isSelected =
//                         selectedRate?.rate_id ===
//                         rate.rate_id;

//                       const price =
//                         getRatePrice(rate);

//                       return (
//                         <button
//                           key={rate.rate_id}
//                           type="button"
//                           onClick={() =>
//                             setSelectedRate(rate)
//                           }
//                           className={`btn text-start border rounded-3 p-3 ${
//                             isSelected
//                               ? "border-primary bg-primary bg-opacity-10"
//                               : "border-light-subtle"
//                           }`}
//                         >
//                           <div className="d-flex align-items-center gap-3">
//                             <div
//                               className={`rounded-circle border d-flex align-items-center justify-content-center flex-shrink-0 ${
//                                 isSelected
//                                   ? "border-primary bg-primary"
//                                   : "border-secondary"
//                               }`}
//                               style={{
//                                 width: 18,
//                                 height: 18,
//                               }}
//                             >
//                               {isSelected && (
//                                 <span
//                                   className="bg-white rounded-circle"
//                                   style={{
//                                     width: 6,
//                                     height: 6,
//                                   }}
//                                 />
//                               )}
//                             </div>

//                             <div className="flex-grow-1">
//                               <div className="d-flex align-items-center gap-2 flex-wrap">
//                                 <span className="fw-semibold small text-dark">
//                                   {rate.service_type ??
//                                     rate.service_name}
//                                 </span>

//                                 {rate.rate_id ===
//                                   cheapestId && (
//                                   <span className="badge bg-success-subtle text-success">
//                                     Cheapest
//                                   </span>
//                                 )}

//                                 {rate.rate_id ===
//                                   fastestId &&
//                                   rate.rate_id !==
//                                     cheapestId && (
//                                     <span className="badge bg-info-subtle text-info">
//                                       Fastest
//                                     </span>
//                                   )}
//                               </div>

//                               <div className="small text-muted mt-1">
//                                 {rate.delivery_days
//                                   ? `${rate.delivery_days} business days`
//                                   : "Delivery time unavailable"}
//                               </div>
//                             </div>

//                             <div className="fw-bold text-dark">
//                               $
//                               {price.toFixed(2)}
//                             </div>
//                           </div>
//                         </button>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Footer */}
//           <div className="modal-footer border-top px-4 py-3">
//             {stepIdx > 0 ? (
//               <button
//                 type="button"
//                 onClick={goBack}
//                 className="btn btn-light d-flex align-items-center gap-2"
//               >
//                 <ArrowLeft size={15} />
//                 Back
//               </button>
//             ) : (
//               <button
//                 type="button"
//                 onClick={onClose}
//                 className="btn btn-light"
//               >
//                 Cancel
//               </button>
//             )}

//             <div className="ms-auto">
//               {step === "dimensions" && (
//                 <button
//                   type="button"
//                   onClick={handleGetRates}
//                   disabled={loadingRates}
//                   className="btn btn-primary d-flex align-items-center gap-2"
//                 >
//                   {loadingRates && (
//                     <Loader2
//                       size={15}
//                       className="spin"
//                     />
//                   )}
//                   Get Rates
//                 </button>
//               )}

//               {step === "rates" && (
//                 <button
//                   type="button"
//                   onClick={handleGenerateLabel}
//                   disabled={!selectedRate || generating}
//                   className="btn btn-success d-flex align-items-center gap-2"
//                 >
//                   {generating && (
//                     <Loader2
//                       size={15}
//                       className="spin"
//                     />
//                   )}
//                   Generate Label
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <style>
//         {`
//           .spin {
//             animation: shipping-spin 1s linear infinite;
//           }

//           @keyframes shipping-spin {
//             from {
//               transform: rotate(0deg);
//             }
//             to {
//               transform: rotate(360deg);
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import {
  Modal,
  Button,
  Spinner,
  Form,
  Alert,
} from "react-bootstrap";
import {
  Truck,
  Package,
  Check,
  ChevronRight,
  ArrowLeft,
  Weight,
  Ruler,
  X,
} from "lucide-react";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";

const STEPS = [
  {
    key: "carrier",
    label: "Carrier",
  },
  {
    key: "package",
    label: "Package",
  },
  {
    key: "rate",
    label: "Rate",
  },
];

const initialDimensions = {
  weightValue: "",
  weightUnit: "ounce",
  height: "",
  width: "",
  length: "",
  dimUnit: "inch",
};

export default function ShippingLabelModal({
  show,
  order,
  onClose,
  onLabelGenerated,
}) {
  const [stepIdx, setStepIdx] = useState(0);

  const [carriers, setCarriers] = useState([]);
  const [loadingCarriers, setLoadingCarriers] = useState(false);
  const [selectedCarrier, setSelectedCarrier] = useState(null);

  const [dimensions, setDimensions] = useState(initialDimensions);
  const [errors, setErrors] = useState({});

  const [rates, setRates] = useState([]);
  const [loadingRates, setLoadingRates] = useState(false);
  const [selectedRate, setSelectedRate] = useState(null);

  const [generating, setGenerating] = useState(false);

  const step = STEPS[stepIdx]?.key;

  useEffect(() => {
    if (!show) return;

    resetModal();
    loadCarriers();
  }, [show]);

  const resetModal = () => {
    setStepIdx(0);
    setCarriers([]);
    setSelectedCarrier(null);
    setDimensions(initialDimensions);
    setErrors({});
    setRates([]);
    setSelectedRate(null);
    setLoadingRates(false);
    setGenerating(false);
  };

  const loadCarriers = async () => {
    setLoadingCarriers(true);

    try {
      const res = await GetService(API_URL.GET_SHIPPING_CARRIERS);

      if (res?.data?.status === false) {
        showErrorAlert(res?.data?.message || "Unable to load carriers");
        return;
      }

      const list =
        res?.data?.data?.carriers ||
        res?.data?.data ||
        res?.data?.carriers ||
        [];

      setCarriers(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error("Carrier API error:", error);
      showErrorAlert(
        error?.response?.data?.message || "Couldn't load shipping carriers"
      );
    } finally {
      setLoadingCarriers(false);
    }
  };

  const selectCarrier = (carrier) => {
    setSelectedCarrier(carrier);
    setErrors({});
    setStepIdx(1);
  };

  const validatePackage = () => {
    const newErrors = {};

    const weight = Number(dimensions.weightValue);
    const height = Number(dimensions.height);
    const width = Number(dimensions.width);
    const length = Number(dimensions.length);

    if (
      dimensions.weightValue === "" ||
      Number.isNaN(weight) ||
      weight <= 0
    ) {
      newErrors.weightValue = "Weight is required and must be greater than 0.";
    }

    if (
      dimensions.height === "" ||
      Number.isNaN(height) ||
      height <= 0
    ) {
      newErrors.height = "Height is required.";
    }

    if (
      dimensions.width === "" ||
      Number.isNaN(width) ||
      width <= 0
    ) {
      newErrors.width = "Width is required.";
    }

    if (
      dimensions.length === "" ||
      Number.isNaN(length) ||
      length <= 0
    ) {
      newErrors.length = "Length is required.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleDimensionChange = (field, value) => {
    if (value !== "" && Number(value) < 0) return;

    setDimensions((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleGetRates = async () => {
    if (!selectedCarrier) {
      showErrorAlert("Please select a carrier");
      setStepIdx(0);
      return;
    }

    if (!validatePackage()) {
      return;
    }

    setLoadingRates(true);
    setRates([]);
    setSelectedRate(null);

    try {
      const payload = {
        carrier_id:
          selectedCarrier?.carrier_id ||
          selectedCarrier?.id ||
          selectedCarrier?.carrierId,

        packages: [
          {
            weight: {
              value: Number(dimensions.weightValue),
              unit: dimensions.weightUnit,
            },

            dimensions: {
              height: Number(dimensions.height),
              width: Number(dimensions.width),
              length: Number(dimensions.length),
              unit: dimensions.dimUnit,
            },
          },
        ],
      };

      const res = await PostService(
        API_URL.GET_SHIPPING_RATES(order?.id),
        payload
      );

      if (res?.data?.status === false) {
        showErrorAlert(
          res?.data?.message || "Couldn't fetch shipping rates"
        );
        return;
      }

      const fetchedRates =
        res?.data?.data?.rates ||
        res?.data?.rates ||
        res?.data?.data ||
        [];

      if (!Array.isArray(fetchedRates)) {
        showErrorAlert("Invalid rate response from server");
        return;
      }

      setRates(fetchedRates);
      setStepIdx(2);
    } catch (error) {
      console.error("Rate API error:", error);

      showErrorAlert(
        error?.response?.data?.message ||
          "Couldn't fetch shipping rates"
      );
    } finally {
      setLoadingRates(false);
    }
  };

  const handleGenerateLabel = async () => {
    if (!selectedRate) {
      showErrorAlert("Please select a shipping rate");
      return;
    }

    setGenerating(true);

    try {
      const payload = {
        rate_id: selectedRate?.rate_id || selectedRate?.id,

        service_name:
          selectedRate?.service_name ||
          selectedRate?.service_type ||
          "",

        carrier_name:
          selectedRate?.carrier_name ||
          selectedCarrier?.carrier_name ||
          selectedCarrier?.friendly_name ||
          "",

        price: Number(
          selectedRate?.price ||
            selectedRate?.rate ||
            selectedRate?.shipping_amount ||
            0
        ),

        delivery_days:
          selectedRate?.delivery_days ||
          selectedRate?.estimated_delivery_days ||
          null,
      };

      const res = await PostService(
        API_URL.GENERATE_SHIPPING_LABEL(order?.id),
        payload
      );

      if (!res?.data?.status) {
        showErrorAlert(
          res?.data?.message || "Couldn't generate shipping label"
        );
        return;
      }

      const labelUrl =
        res?.data?.data?.label_url ||
        res?.data?.label_url ||
        res?.data?.data?.labelUrl;

      showSuccessAlert(
        res?.data?.message || "Shipping label generated successfully"
      );

      if (labelUrl) {
        window.open(
          labelUrl,
          "_blank",
          "noopener,noreferrer"
        );
      }

      onLabelGenerated?.(res?.data);

      onClose();
    } catch (error) {
      console.error("Generate label error:", error);

      showErrorAlert(
        error?.response?.data?.message ||
          "Couldn't generate shipping label"
      );
    } finally {
      setGenerating(false);
    }
  };

  const cheapestId = useMemo(() => {
    if (!rates.length) return null;

    return rates.reduce((a, b) => {
      const aPrice = Number(
        a?.price || a?.rate || a?.shipping_amount || 0
      );

      const bPrice = Number(
        b?.price || b?.rate || b?.shipping_amount || 0
      );

      return aPrice <= bPrice ? a : b;
    })?.rate_id;
  }, [rates]);

  const fastestId = useMemo(() => {
    if (!rates.length) return null;

    return rates.reduce((a, b) => {
      const aDays = Number(a?.delivery_days ?? 999);
      const bDays = Number(b?.delivery_days ?? 999);

      return aDays <= bDays ? a : b;
    })?.rate_id;
  }, [rates]);

  const goBack = () => {
    if (stepIdx > 0) {
      setErrors({});
      setStepIdx((prev) => prev - 1);
    }
  };

  const renderCarrierStep = () => {
    if (loadingCarriers) {
      return (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <div className="mt-3 text-muted">
            Loading carriers...
          </div>
        </div>
      );
    }

    if (!carriers.length) {
      return (
        <Alert variant="warning">
          No shipping carriers are available.
        </Alert>
      );
    }

    return (
      <div>
        <div className="mb-3">
          <h6 className="font-weight-bold mb-1">
            Select Carrier
          </h6>

          <small className="text-muted">
            Choose the carrier you want to use for this shipment.
          </small>
        </div>

        {carriers.map((carrier) => {
          const carrierId =
            carrier?.carrier_id ||
            carrier?.id ||
            carrier?.carrierId;

          const carrierName =
            carrier?.friendly_name ||
            carrier?.carrier_name ||
            carrier?.name ||
            carrierId;

          const isSelected =
            selectedCarrier &&
            (
              selectedCarrier?.carrier_id ||
              selectedCarrier?.id ||
              selectedCarrier?.carrierId
            ) === carrierId;

          return (
            <button
              type="button"
              key={carrierId}
              onClick={() => selectCarrier(carrier)}
              className={`btn btn-block text-left border rounded mb-2 p-2 ${
                isSelected
                  ? "border-primary bg-light"
                  : ""
              }`}
              style={{
                transition: "0.2s",
              }}
            >
              <div className="d-flex align-items-center">
                <div
                  className={`rounded d-flex align-items-center justify-content-center mr-3 ${
                    isSelected
                      ? "bg-primary text-white"
                      : "bg-light text-secondary"
                  }`}
                  style={{
                    width: 42,
                    height: 42,
                  }}
                >
                  <Truck size={18} />
                </div>

                <div className="flex-grow-1">
                  <div className="font-weight-bold text-dark">
                    {carrierName}
                  </div>

                  {carrier?.description && (
                    <small className="text-muted">
                      {carrier.description}
                    </small>
                  )}
                </div>

                <ChevronRight
                  size={18}
                  className={
                    isSelected
                      ? "text-primary"
                      : "text-muted"
                  }
                />
              </div>
            </button>
          );
        })}
      </div>
    );
  };

  const renderPackageStep = () => {
    const carrierName =
      selectedCarrier?.friendly_name ||
      selectedCarrier?.carrier_name ||
      selectedCarrier?.name ||
      selectedCarrier?.carrier_id;

    return (
      <div>
        <div className="alert alert-primary d-flex align-items-center">
          <Truck size={17} className="mr-2" />

          <div>
            Carrier:{" "}
            <strong>{carrierName}</strong>
          </div>
        </div>

        <div className="card border-0 bg-light mb-3">
          <div className="card-body">
            <h6 className="font-weight-bold mb-3">
              <Weight size={15} className="mr-2" />
              Weight
            </h6>

            <div className="form-group mb-0">
              <div className="input-group">
                <Form.Control
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0"
                  value={dimensions.weightValue}
                  onChange={(e) =>
                    handleDimensionChange(
                      "weightValue",
                      e.target.value
                    )
                  }
                  onWheel={(e) => e.currentTarget.blur()}
                />

                <div className="input-group-append">
                  <span className="input-group-text">
                    oz
                  </span>
                </div>
              </div>

              {errors.weightValue && (
                <small className="text-danger">
                  {errors.weightValue}
                </small>
              )}
            </div>
          </div>
        </div>

        <div className="card border-0 bg-light">
          <div className="card-body">
            <h6 className="font-weight-bold mb-3">
              <Ruler size={15} className="mr-2" />
              Dimensions (in)
            </h6>

            <div className="row">
              <div className="col-md-4">
                <Form.Group>
                  <Form.Label>
                    Height
                  </Form.Label>

                  <Form.Control
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={dimensions.height}
                    onChange={(e) =>
                      handleDimensionChange(
                        "height",
                        e.target.value
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                  />

                  {errors.height && (
                    <small className="text-danger">
                      {errors.height}
                    </small>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-4">
                <Form.Group>
                  <Form.Label>
                    Width
                  </Form.Label>

                  <Form.Control
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={dimensions.width}
                    onChange={(e) =>
                      handleDimensionChange(
                        "width",
                        e.target.value
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                  />

                  {errors.width && (
                    <small className="text-danger">
                      {errors.width}
                    </small>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-4">
                <Form.Group>
                  <Form.Label>
                    Length
                  </Form.Label>

                  <Form.Control
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0"
                    value={dimensions.length}
                    onChange={(e) =>
                      handleDimensionChange(
                        "length",
                        e.target.value
                      )
                    }
                    onWheel={(e) => e.currentTarget.blur()}
                  />

                  {errors.length && (
                    <small className="text-danger">
                      {errors.length}
                    </small>
                  )}
                </Form.Group>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderRatesStep = () => {
    if (!rates.length) {
      return (
        <div className="text-center py-5">
          <Package
            size={35}
            className="text-muted"
          />

          <h6 className="mt-3">
            No rates found
          </h6>

          <p className="text-muted small mb-0">
            No shipping rates are available for this
            carrier and package.
          </p>
        </div>
      );
    }

    return (
      <div>
        <div className="mb-3">
          <h6 className="font-weight-bold">
            Select Shipping Rate
          </h6>

          <small className="text-muted">
            Select the rate you want to use to generate
            the shipping label.
          </small>
        </div>

        {rates.map((rate) => {
          const rateId =
            rate?.rate_id || rate?.id;

          const price = Number(
            rate?.price ||
              rate?.rate ||
              rate?.shipping_amount ||
              0
          );

          const serviceName =
            rate?.service_type ||
            rate?.service_name ||
            rate?.service ||
            "Shipping Service";

          const deliveryDays =
            rate?.delivery_days ??
            rate?.estimated_delivery_days;

          const selected =
            selectedRate &&
            (
              selectedRate?.rate_id ||
              selectedRate?.id
            ) === rateId;

          const isCheapest =
            rate?.rate_id === cheapestId;

          const isFastest =
            rate?.rate_id === fastestId;

          return (
            <button
              type="button"
              key={rateId}
              onClick={() => setSelectedRate(rate)}
              className={`btn btn-block text-left border rounded mb-2 p-3 ${
                selected
                  ? "border-primary bg-light"
                  : "border-light"
              }`}
            >
              <div className="d-flex align-items-center">
                <div
                  className={`rounded-circle border d-flex align-items-center justify-content-center mr-3 ${
                    selected
                      ? "border-primary bg-primary"
                      : "border-secondary"
                  }`}
                  style={{
                    width: 18,
                    height: 18,
                  }}
                >
                  {selected && (
                    <Check
                      size={11}
                      className="text-white"
                    />
                  )}
                </div>

                <div className="flex-grow-1">
                  <div className="d-flex align-items-center flex-wrap">
                    <strong className="text-dark mr-2">
                      {serviceName}
                    </strong>

                    {isCheapest && (
                      <span className="badge badge-success mr-1">
                        Cheapest
                      </span>
                    )}

                    {isFastest &&
                      !isCheapest && (
                        <span className="badge badge-info">
                          Fastest
                        </span>
                      )}
                  </div>

                  <small className="text-muted">
                    {deliveryDays
                      ? `${deliveryDays} business days`
                      : "Delivery time unavailable"}
                  </small>
                </div>

                <div className="font-weight-bold text-primary">
                  ${price.toFixed(2)}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="md"
      backdrop="static"
      keyboard={!generating}
    >
      <Modal.Header className="border-bottom">
        <div className="d-flex align-items-center flex-grow-1">
          <div
            className="bg-primary text-white rounded d-flex align-items-center justify-content-center mr-3"
            style={{
              width: 42,
              height: 42,
            }}
          >
            <Truck size={19} />
          </div>

          <div>
            <h5 className="mb-0 font-weight-bold">
              Generate Shipping Label
            </h5>

            <small className="text-muted">
              {order?.order_no ||
                order?.order_number ||
                `Order #${order?.id}`}
            </small>
          </div>
        </div>

        <button
          type="button"
          className="close"
          onClick={onClose}
          disabled={generating}
        >
          <X size={20} />
        </button>
      </Modal.Header>

      <div className="px-4 pt-4">
        <div className="d-flex align-items-center">
          {STEPS.map((item, index) => {
            const completed = index < stepIdx;
            const current = index === stepIdx;

            return (
              <React.Fragment key={item.key}>
                <div
                  className="d-flex align-items-center"
                  style={{
                    cursor:
                      completed
                        ? "pointer"
                        : "default",
                  }}
                  onClick={() => {
                    if (completed) {
                      setStepIdx(index);
                    }
                  }}
                >
                  <div
                    className={`rounded-circle d-flex align-items-center justify-content-center ${
                      completed
                        ? "bg-success text-white"
                        : current
                        ? "bg-primary text-white"
                        : "bg-light text-muted"
                    }`}
                    style={{
                      width: 30,
                      height: 30,
                      fontSize: 12,
                      fontWeight: 700,
                    }}
                  >
                    {completed ? (
                      <Check size={14} />
                    ) : (
                      index + 1
                    )}
                  </div>

                  <small
                    className={`ml-2 font-weight-bold ${
                      current
                        ? "text-primary"
                        : completed
                        ? "text-dark"
                        : "text-muted"
                    }`}
                  >
                    {item.label}
                  </small>
                </div>

                {index < STEPS.length - 1 && (
                  <div
                    className={`flex-grow-1 mx-2 ${
                      index < stepIdx
                        ? "bg-success"
                        : "bg-light"
                    }`}
                    style={{
                      height: 2,
                    }}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>

      <Modal.Body
        style={{
          minHeight: 360,
          maxHeight: "55vh",
          overflowY: "auto",
        }}
      >
        {step === "carrier" &&
          renderCarrierStep()}

        {step === "package" &&
          renderPackageStep()}

        {step === "rate" &&
          renderRatesStep()}
      </Modal.Body>

      <Modal.Footer className="border-top">
        {stepIdx > 0 ? (
          <Button
            variant="light"
            className="btn-sm"
            onClick={goBack}
            disabled={loadingRates || generating}
          >
            <ArrowLeft
              size={15}
              className="mr-1"
            />
            Back
          </Button>
        ) : (
          <div />
        )}

        {step === "package" && (
          <Button
            variant="primary"
            className="btn-sm"
            onClick={handleGetRates}
            disabled={loadingRates}
          >
            {loadingRates && (
              <Spinner
                animation="border"
                size="sm"
                className="mr-2"
              />
            )}

            Get Rates
          </Button>
        )}

        {step === "rate" && (
          <Button
            variant="success"
            className="btn-sm"
            onClick={handleGenerateLabel}
            disabled={!selectedRate || generating}
          >
            {generating && (
              <Spinner
                animation="border"
                size="sm"
                className="mr-2"
              />
            )}

            Generate Label
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
